package com.timacookies.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent

@Composable
fun FloatingBackToTop() {
  var isVisible by remember { mutableStateOf(false) }

  DisposableEffect(Unit) {
    val listener = { _: org.w3c.dom.events.Event ->
      isVisible = window.scrollY > 300
    }
    window.addEventListener("scroll", listener)
    onDispose {
      window.removeEventListener("scroll", listener)
    }
  }

  Button(
    onClick = { window.scrollTo(0.0, 0.0) },
    modifier = Modifier
      .position(Position.Fixed)
      .bottom(2.cssRem)
      .right(2.cssRem)
      .size(3.cssRem)
      .borderRadius(50.percent)
      .cursor(Cursor.Pointer)
      .zIndex(100)
      .opacity(if (isVisible) 0.8 else 0.0)
      .padding(bottom = 0.2.cssRem) // Visual centering adjustment for the arrow
      .transition {
        property("opacity")
        duration(300.ms)
      },
  ) {
    SpanText("↑", Modifier.fontSize(1.5.cssRem))
  }
}
